'use client';

import React from 'react';

import { useModal } from '@/contexts/ModalContext';

const HintModal: React.FC = () => {
  const { closeModal } = useModal();
  /**
   *
   */
  const handleModalClick = (e: React.MouseEvent<HTMLDivElement>) => {
    // モーダルの背景をクリックした場合にだけ closeModal を呼び出す
    const modalBackground = document.getElementById('modal-background');
    if (e.target === modalBackground) {
      closeModal();
    }
  };

  return (
    <div
      id="modal-background"
      className="fixed inset-0 z-30 w-full flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none"
      onClick={handleModalClick}>
      <div className="relative w-11/12 sm:w-6/12 max-h-[85dvh] overflow-y-auto rounded-lg">
        <div className="relative flex flex-col bg-white border-0 rounded-lg outline-none focus:outline-none">
          <div className="flex justify-between items-center border-b border-green-500 px-4 py-2 bg-white sticky top-0 z-10 rounded-t-lg">
            <h3 className="flex items-center font-footballlog italic text-sm font-semibold text-gray-500 dark:text-white">
              目標設定のヒント
            </h3>
            <button
              type="button"
              onClick={closeModal}
              className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 flex items-center justify-center dark:hover:bg-gray-600 dark:hover:text-white">
              <svg
                className="w-3 h-3"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 14 14">
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                />
              </svg>
              <span className="sr-only">Close menu</span>
            </button>
          </div>
          <div className="relative p-4 overflow-y-auto">
            <div className="bg-gray-100 p-4 rounded-lg">
              <h4 className="flex items-center font-footballlog italic font-semibold text-gray-200 text-5xl">
                <svg
                  className="w-8 h-8"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="20"
                  fill="none"
                  viewBox="0 0 14 20">
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M4 7a3 3 0 0 1 3-3M5 19h4m0-3c0-4.1 4-4.9 4-9A6 6 0 1 0 1 7c0 4 4 5 4 9h4Z"
                  />
                </svg>
                Hints
              </h4>
              <ul className="list my-4 text-gray-600 text-sm">
                <li className="my-4 flex items-top space-x-3 rtl:space-x-reverse">
                  <svg
                    className="mt-1 flex-shrink-0 w-3.5 h-3.5 text-green-500"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 16 12">
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M1 5.917 5.724 10.5 15 1.5"
                    />
                  </svg>
                  <span>サッカーに取り組む前に、その日の重点的に意識するMy Goals（目標・課題）を設定しましょう。</span>
                </li>
                <li className="my-4">
                  <div className="flex items-top space-x-3 rtl:space-x-reverse">
                    <svg
                      className="mt-1 flex-shrink-0 w-3.5 h-3.5 text-green-500"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 16 12">
                      <path
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M1 5.917 5.724 10.5 15 1.5"
                      />
                    </svg>
                    <span>確実にステップアップするために、具体的なMy Goalsを設定しましょう。</span>
                  </div>
                  <ul className="ps-10 mt-2 space-y-1 list-disc list-inside">
                    <li className="my-2 -indent-4">ex.「ボールばかり見ない。間接視野を意識して常に状況把握する。」</li>
                    <li className="my-2 -indent-4">ex.「縦パスの意識。ミニゲームで３本以上有効な縦パスを通す。」</li>
                    <li className="my-2 -indent-4">具体的な内容や数値を掲げることが重要です。</li>
                  </ul>
                </li>

                <li className="my-4 flex items-top space-x-3 rtl:space-x-reverse">
                  <svg
                    className="mt-1 flex-shrink-0 w-3.5 h-3.5 text-green-500"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 16 12">
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M1 5.917 5.724 10.5 15 1.5"
                    />
                  </svg>
                  <span>
                    作成したMy Goalsは繰り返し切り替えができます。目標の切り替えは目標一覧から行えます。同じ内容のMy
                    Goalsは都度作成する必要はありません。
                  </span>
                </li>
                <li className="my-4 flex items-top space-x-3 rtl:space-x-reverse">
                  <svg
                    className="mt-1 flex-shrink-0 w-3.5 h-3.5 text-green-500"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 16 12">
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M1 5.917 5.724 10.5 15 1.5"
                    />
                  </svg>
                  <span>
                    現在設定中のMy Goalsは、サッカーノートを記録する際に「My
                    Goals（今の目標・課題）」として表示されます。目標を常に意識してサッカーノートを記録しましょう。
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HintModal;
